import {getHttpClient} from './client'

export const getAllRoles = async () => {
    return await getHttpClient(process.env.VUE_APP_API_URL + "/role")
        .then(response => response.data)
}